import { produce } from 'immer';

import { SaveImportWizardFile } from '../../actions/importWizard/saveImportWizardFile';
import { ImportWizardPhase, ImportWizardState } from '../../typings/importWizard';

export const saveImportWizardFile = (state: ImportWizardState, action: SaveImportWizardFile): ImportWizardState => {
    return produce(state, draft => {
        draft.importFile = action.file
            ? {
                  file: action.file,
                  mdsGroupId: '',
                  name: ''
              }
            : undefined;

        if (draft.phase === ImportWizardPhase.FILE_UPLOAD) {
            draft.errors = [];
        }
    });
};
